(function () {
  var SEC = 1000;
  var MIN = 60 * SEC;
  var HR = 60 * MIN;
  var DAY = 24 * HR;
  var GRACE = 2 * HR;

  function pad(value) {
    return String(Math.max(0, Math.floor(value))).padStart(2, '0');
  }

  function parts(ms) {
    var safe = Math.max(0, ms);
    return {
      days: Math.floor(safe / DAY),
      hours: Math.floor((safe % DAY) / HR),
      hoursTotal: Math.floor(safe / HR),
      minutes: Math.floor((safe % HR) / MIN),
      seconds: Math.floor((safe % MIN) / SEC),
    };
  }

  function stateFromMs(ms) {
    if (ms <= 0) return 'expired';
    if (ms > DAY) return 'days';
    return 'normal';
  }

  function pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName, ab_variant: 'countdown' }, payload || {}));
  }

  var KualaSaleCountdown = {
    config: null,
    offset: 0,
    timer: null,
    state: 'hidden',
    viewed: false,
    lastAtcSource: 'main',

    now: function () {
      return Date.now() + this.offset;
    },

    remaining: function () {
      if (!this.config) return 0;
      return this.config.endsAtMs - this.now();
    },

    init: function (config) {
      if (!config || this.config) return;
      this.config = config;
      this.offset = config.serverNowMs - Date.now();

      var remaining = this.remaining(); 
      var duration = config.endsAtMs - config.startsAtMs;
      if (remaining > duration) {
        this.hideAll();
        return;
      }
      if (remaining <= -GRACE) {
        this.hideAll();
        return;
      }

      this.bindAtcSource();
      this.tick();
      if (remaining >= 1000 && !this.timer) {
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
    },

    stop: function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    hideAll: function () {
      this.stop();
      this.state = 'hidden';
      document.querySelectorAll('[data-sale-countdown]').forEach(function (el) {
        el.remove();
      });
      document.documentElement.classList.remove('pdp-sale-countdown-active', 'pdp-sale-countdown-sticky-visible');
      document.documentElement.style.setProperty('--sticky-atc-bar-height', '0px');
    },

    bindAtcSource: function () {
      document.addEventListener(
        'click',
        function (event) {
          var button = event.target.closest('[name="add"]');
          if (!button) return;
          this.lastAtcSource = button.closest('sticky-atc-bar-minimalist, sticky-atc-bar') ? 'sticky' : 'main';
        }.bind(this),
        true
      );
      document.addEventListener(
        'product-ajax:added',
        function () {
          this.trackAddToCart();
        }.bind(this)
      );
    },

    trackAddToCart: function () {
      pushDataLayer('add_to_cart', {
        timer_state: this.state,
        source: this.lastAtcSource,
      });
    },

    trackViews: function (state) {
      if (state === 'hidden' || state === 'expired') return;
      if (!this.viewed) {
        this.viewed = true;
        pushDataLayer('pdp_timer_view', { timer_state: state });
      }
    },

    tick: function () {
      var remaining = this.remaining();
      if (remaining < 1000) {
        this.stop();
        this.applyState('expired', remaining);
        return;
      }
      if (remaining <= -GRACE) {
        this.hideAll();
        return;
      }
      var next = stateFromMs(remaining);
      this.applyState(next, remaining);
    },

    applyState: function (state, remaining) {
      this.state = state;
      this.trackViews(state);
      var time = parts(remaining);
      document.querySelectorAll('[data-sale-countdown="block"]').forEach(function (el) {
        this.renderBlock(el, state, time);
      }, this);
      document.querySelectorAll('[data-sale-countdown="sticky"]').forEach(function (el) {
        this.renderSticky(el, state, time);
      }, this);
      if (state === 'expired') {
        this.scheduleRemoval();
      }
    },

    scheduleRemoval: function () {
      var remainingGrace = this.remaining() + GRACE;
      if (remainingGrace <= 0) {
        this.hideAll();
        return;
      }
      setTimeout(this.hideAll.bind(this), remainingGrace);
    },

    renderBlock: function (el, state, time) {
      var strings = (this.config && this.config.strings) || {};
      var name = (this.config && this.config.name) || el.getAttribute('data-campaign-name') || '';
      var live = el.querySelector('.pdp-sale-countdown__live');
      var expired = el.querySelector('.pdp-sale-countdown__expired');

      el.classList.remove('pdp-sale-countdown--days', 'pdp-sale-countdown--normal', 'pdp-sale-countdown--urgent', 'pdp-sale-countdown--expired');
      el.classList.add('pdp-sale-countdown--' + state);

      if (state === 'expired') {
        if (live) live.hidden = true;
        if (expired) expired.hidden = false;
        return;
      }

      if (live) live.hidden = false;
      if (expired) expired.hidden = true;

      var title = el.querySelector('.pdp-sale-countdown__title');
      var subtitle = el.querySelector('.pdp-sale-countdown__subtitle');
      if (title) title.textContent = name;
      if (subtitle) subtitle.textContent = strings.endsIn;

      var slots = el.querySelectorAll('[data-slot]');
      var values;
      var labels;
      if (state === 'days') {
        values = [pad(time.days), pad(time.hours), pad(time.minutes)];
        labels = [strings.days, strings.hours, strings.minutes];
      } else {
        values = [pad(time.hoursTotal), pad(time.minutes), pad(time.seconds)];
        labels = [strings.hours, strings.minutes, strings.seconds];
      }

      slots.forEach(function (slot, index) {
        var digit = slot.querySelector('[data-digit]');
        var label = slot.querySelector('[data-unit-label]');
        if (digit) digit.textContent = values[index];
        if (label) label.textContent = labels[index];
        if (index === 2 && state !== 'days') {
          slot.setAttribute('aria-hidden', 'true');
        } else {
          slot.removeAttribute('aria-hidden');
        }
      });
    },

    renderSticky: function (el, state, time) {
      var strings = (this.config && this.config.strings) || {};
      var root = el.closest('sticky-atc-bar-minimalist') || el;
      var expired = state === 'expired' || state === 'hidden';
      root.classList.toggle('sticky-atc-bar--timer-expired', expired);
      root.classList.remove('sticky-atc-bar--timer-urgent');

      if (expired) return;

      var labels = root.querySelectorAll('[data-sticky-timer-label]');
      var digits = root.querySelectorAll('[data-sticky-timer-digits]');
      var labelText = strings.stickyLabel;
      var digitsText = pad(time.hoursTotal) + ':' + pad(time.minutes) + ':' + pad(time.seconds);
      var hideLabel = false;

      if (state === 'days') {
        hideLabel = true;
        var clock = pad(time.hours) + ':' + pad(time.minutes);
        var template = strings.stickyDaysOther || '';
        if (time.days === 1) template = strings.stickyDaysOne || template;
        else if (time.days === 2) template = strings.stickyDaysTwo || template;
        digitsText = template.replace('__COUNT__', String(time.days)).replace('__TIME__', clock);
      }

      labels.forEach(function (labelEl) {
        labelEl.textContent = labelText;
        labelEl.hidden = hideLabel;
      });
      digits.forEach(function (digitsEl) {
        digitsEl.textContent = digitsText;
      });
    },
  };

  window.KualaSaleCountdown = KualaSaleCountdown;

  function boot() {
    var campaign = window.FoxTheme && FoxTheme.saleCampaign;
    if (!campaign || !campaign.enabled) return;
    var endsAtMs = campaign.endsAtSec * 1000;
    var startsAtMs = campaign.startsAtSec * 1000;
    var topbarTimer = document.querySelector('.topbar__timer countdown-timer[data-due-date]');
    if (topbarTimer && topbarTimer.dataset.dueDate) {
      var parsed = new Date(topbarTimer.dataset.dueDate).getTime();
      if (!isNaN(parsed)) endsAtMs = parsed;
    }
    KualaSaleCountdown.init({
      name: campaign.name,
      coupon: campaign.coupon,
      strings: campaign.strings,
      endsAtMs: endsAtMs,
      startsAtMs: startsAtMs,
      serverNowMs: campaign.serverNowSec * 1000,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
